import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ParentOne from "../../assets/images/clients/parentOne.png";
import ParentTwo from "../../assets/images/clients/parentTwo.png";
import ParentThree from "../../assets/images/clients/parentThree.png";

import Card from "./Card";

const responsive = {
  desktop: {
    breakpoint: { max: 5000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1100, min: 600 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 600, min: 200 },
    items: 1,
  },
};

const Slider = () => {
  const testimonials = [
    {
      writer: "F.Zahiti",
      profilePicture: ParentOne,
      role: "Parent",
      description:
        "I congratulate you and thank you for your achievements through your students. Every achievement of theirs is credited to you as the academy staff. As Amira's parent, I am extremely pleased with your evaluation and comments.",
    },
    {
      writer: "Y.Krasniqi",
      profilePicture: ParentTwo,
      role: "Parent",
      description:
        "A big thank you goes to the English teacher, whose dedication has helped Ylljeta achieve more advanced success and she continues to enjoy the lesson. I also feel very happy with Jeta's behavior and the harmony she creates in the classroom.",
    },
    {
      writer: "A.Selimi",
      profilePicture: ParentThree,
      role: "Parent",
      description:
        "Reina is lucky to be taking programming lessons at your Innovation Academy! She has a wonderful teacher, I wish you good luck and continued success.",
    },
    {
      writer: "I.Sejdiu",
      profilePicture: "",
      role: "Parent",
      description:
        "I thank you from the bottom of my heart for the dedication, professionalism and support you show every day. Thanks to your work, Inara and Menesa have the opportunity to develop their knowledge and be inspired to achieve more. You are a great example of teamwork and dedication to everyone's success.",
    },
    {
      writer: "A. Meholli",
      profilePicture: "",
      role: "Parent",
      description:
        "Thank you Innovation Academy! A special thank you goes to Engjëllit’s professor, Mr. Korab Duklini. As Engjëllit’s parent, I want to congratulate you from the bottom of my heart for your tireless work and for the opportunity you have given not only to Engjëllit, but also to all the other children. I hope that Engjëllit will continue with commitment and dedication in his educational journey. Further success to all of you!",
    },
    {
      writer: "L. Hyseni",
      profilePicture: "",
      role: "Parent",
      description:
        "Thank you very much for this appreciation for Lorena. As Lorena's mother, I congratulate you for the extraordinary work and will you do for the children. Thank you once again and continued success!",
    },
    {
      writer: "O. Krasniqi",
      profilePicture: "",
      role: "Parent",
      description:
        "First, I would like to thank the entire staff of Innovation Academy for their extraordinary dedication to their students, as well as Professor Korab, who has never failed to keep us informed about my child's development. Thank you very much!",
    },
    {
      writer: "A. Maloku",
      profilePicture: "",
      role: "Parent",
      description:
        "Congratulations from the bottom of my heart! Thank you to you as a staff for the care, dedication and attention you show every day towards the learning and well-being of our children. It is to be appreciated the way you exercise your role with such responsibility and love. You are a precious support for their educational journey",
    },
  ];

  return (
    <Carousel
      responsive={responsive}
      swipeable={true}
      draggable={true}
      showDots={false}
      dotListClass="custom-dot-list-style"
    >
      {testimonials.map((testimonial, index) => {
        return (
          <Card
            key={index}
            testimonial={testimonial.description}
            index={index}
            writer={testimonial.writer}
            src={testimonial.profilePicture}
            position={testimonial.role}
          />
        );
      })}
    </Carousel>
  );
};
export default Slider;
